import { css } from '@emotion/css';
import { ColorConstant, Font } from 'src/styles';

export const error = css`
  color: ${ColorConstant.RED6} !important;
  ${Font.md}
`;
